import * as React from "react";
const createComponentThatRendersItsChildren = (displayName) => {
  const Element = ({ children }) => typeof children === "string" ? React.createElement("div", {}, children) : children;
  Element.displayName = displayName;
  return Element;
};
export {
  createComponentThatRendersItsChildren
};
//# sourceMappingURL=createComponentThatRendersItsChildren.js.map
